module.exports = __webpack_public_path__ + "static/media/background1.9acb5388.jpg";